<template>
    <b-modal scrollable size="xl" v-model="showModal" :title="$t(`message.declaration`)">
        <p class="mt-1">Do you have pre-existing medical conditions?</p>
        <p class="mt-2">If yes, please choose one of the following options to request approval:</p>
        <ul class="mb-3">
            <li>
            Download and complete the medical form 
                <b-link class="btn btn-outline-secondary btn-sm msl_custom" :href="pdfLink" target="_blank"><font-awesome-icon icon="fa-solid fa-eye" /> View</b-link> 
                <b-link class="btn btn-outline-secondary btn-sm msl_custom" :href="pdfLink" download><font-awesome-icon icon="fa-solid fa-download" /> Download</b-link> then email it to 
                <a href="mailto:customer-support@safetravel.today">
                customer-support@safetravel.today
                </a>
            </li>
            <li class="mt-1">Or fill in and submit the form below</li>
        </ul>
        <!-- medical declaration form -->
        <h5 class="my-2">INDIVIDUAL TRAVEL INSURANCE APPLICATION FORM</h5>
        <!-- TOP ALERT: List all errors -->
        <b-alert v-if="Object.keys(errors).length > 0" variant="danger" show class="p-2" ref="mederrorAlert">
            <strong>Please fix the following errors:</strong>
            <ul class="mb-0 mt-2">
                <li v-for="(msg, field) in errors" :key="field">
                    {{ msg }}
                </li>
            </ul>
        </b-alert>
        <b-form @submit.prevent="handleSubmit" autocomplete="off">
            <b-row>
            <b-col cols="12" md="6">
                <!-- title -->
                <b-form-group id="input-group-mdtitle-0" label="Title" label-for="input-mdtitle-0">
                <b-form-select
                    id="input-mdtitle-0"
                    v-model="localForm.travellers[0].title"
                    :options="travellerSelect"
                    required
                ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- first name -->
                <b-form-group id="input-group-mdfirstname-0" label="First Name" label-for="input-mdfirstname-0">
                <b-form-input
                    id="input-mdfirstname-0"
                    v-model="localForm.travellers[0].firstname"
                    placeholder="Enter first name"
                    minlength="3"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- last name -->
                <b-form-group id="input-group-mdlastname-0" label="Family Name" label-for="input-mdlastname-0">
                <b-form-input
                    id="input-mdlastname-0"
                    v-model="localForm.travellers[0].lastname"
                    placeholder="Enter family name"
                    minlength="3"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- dob -->
                <b-form-group id="input-group-mddob-0" label="Date of Birth" label-for="input-mddob-0">
                <b-form-input
                    id="input-mddob-0"
                    v-model="localForm.travellers[0].dob"
                    type="date"
                    :max="dateToday"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- age -->
                <b-form-group id="input-group-mdage-0" label="Age" label-for="input-mdage-0">
                <b-form-input
                    id="input-mdage-0"
                    v-model="localForm.travellers[0].age"
                    type="number"
                    placeholder="Enter age"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            <!-- Add Co-traveller Button -->
            <b-col cols="12" class="mb-1">
                <b-button
                    size="sm"
                    variant="outline-success"
                    @click="addTraveller"
                    v-if="localForm.travellers.length < 10"
                    title="Add another co-traveller"
                >
                    <font-awesome-icon icon="fa-solid fa-plus" /> Add Co-traveller
                </b-button>
            </b-col>
            </b-row>

            <!-- Co-travellers (Starting from index 1) -->
            <b-row 
            v-for="(traveller, index) in localForm.travellers.slice(1)" 
            :key="`traveller-${index + 1}`"
            class="traveller-section mt-1 mb-3"
            >
            <b-col cols="12">
                <div class="d-flex justify-content-between align-items-center mb-2">
                <span class="badge badge-info">Co-traveller {{ index + 1 }}</span>
                <b-button
                    size="sm"
                    variant="outline-danger"
                    @click="removeTraveller(index + 1)"
                    title="Remove co-traveller"
                >
                    <font-awesome-icon icon="fa-solid fa-trash" /> Remove
                </b-button>
                </div>
            </b-col>

            <!-- travellers[index + 1] -->
            <b-col cols="12" md="6">
                <b-form-group 
                :id="`input-group-mdtitle-${index + 1}`" 
                label="Title" 
                :label-for="`input-mdtitle-${index + 1}`"
                >
                <b-form-select
                    :id="`input-mdtitle-${index + 1}`"
                    v-model="localForm.travellers[index + 1].title"
                    :options="travellerSelect"
                    required
                ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- first name -->
                <b-form-group 
                    :id="`input-group-mdfirstname-${index + 1}`"
                    label="First Name" 
                    :label-for="`input-mdfirstname-${index + 1}`"
                >
                <b-form-input
                    :id="`input-mdfirstname-${index + 1}`"
                    v-model="localForm.travellers[index + 1].firstname"
                    placeholder="Enter first name"
                    minlength="3"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- last name -->
                <b-form-group 
                    :id="`input-group-mdlastname-${index + 1}`"
                    label="Family Name" 
                    :label-for="`input-mdlastname-${index + 1}`"
                >
                <b-form-input
                    :id="`input-mdlastname-${index + 1}`"
                    v-model="localForm.travellers[index + 1].lastname"
                    placeholder="Enter family name"
                    minlength="3"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- dob -->
                <b-form-group 
                    :id="`input-group-mddob-${index + 1}`"
                    label="Date of Birth" 
                    :label-for="`input-mddob-${index + 1}`"
                >
                <b-form-input
                    :id="`input-mddob-${index + 1}`"
                    v-model="localForm.travellers[index + 1].dob"
                    type="date"
                    :max="dateToday"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- age -->
                <b-form-group 
                    :id="`input-group-mdage-${index + 1}`"
                    label="Age" 
                    :label-for="`input-mdage-${index + 1}`"
                >
                <b-form-input
                    :id="`input-mdage-${index + 1}`"
                    v-model="localForm.travellers[index + 1].age"
                    type="number"
                    placeholder="Enter age"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            </b-row>

            <b-row class="mt-1">
            <b-col cols="12" md="6">
                <!-- Country of Residence -->
                <b-form-group id="input-group-mdcountry" label="Country of Residence" label-for="input-mdcountry">
                <b-form-input
                    id="input-mdcountry"
                    v-model="localForm.country"
                    placeholder="Enter country of residence"
                    minlength="3"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- Address -->
                <b-form-group id="input-group-mdaddress" label="Address" label-for="input-mdaddress">
                <b-form-input
                    id="input-mdaddress"
                    v-model="localForm.address"
                    placeholder="Enter address"
                    minlength="3"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- Telephone -->
                <b-form-group id="input-group-mdtelephone" label-for="input-mdtelephone">
                <template #label>
                    Telephone
                    <span class="text-muted">(Optional)</span>
                </template>
                <b-form-input
                    id="input-mdtelephone"
                    type="tel"
                    pattern="^[0-9+ ]+$"
                    v-model="localForm.telephone"
                    placeholder="Enter telephone"
                ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- Mobile -->
                <b-form-group id="input-group-mdmobile" label="Mobile" label-for="input-mdmobile">
                <b-form-input
                    id="input-mdmobile"
                    type="tel"
                    pattern="^[0-9+ ]+$"
                    v-model="localForm.mobile"
                    placeholder="Enter mobile"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- Email -->
                <b-form-group id="input-group-mdemail" label="Email" label-for="input-mdemail">
                <b-form-input
                    id="input-mdemail"
                    v-model="localForm.email"
                    type="email"
                    placeholder="Enter email"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            </b-row>

            <b-row class="mt-1">
            <b-col cols="12" md="6">
                <!-- Policy/Trip Start Date -->
                <b-form-group id="input-group-mdstartdate" label="Policy/Trip Start Date" label-for="input-mdstartdate">
                <b-form-input
                    id="input-mdstartdate"
                    v-model="localForm.start_date"
                    type="date"
                    :min="dateToday"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- Policy/Trip End Date -->
                <b-form-group id="input-group-mdenddate" label="Policy/Trip End Date" label-for="input-mdenddate">
                <b-form-input
                    id="input-mdenddate"
                    v-model="localForm.end_date"
                    type="date"
                    :min="dateToday"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- Policy Type Single Trip/Annual/Long Stay -->
                <b-form-group id="input-group-mdpolicytype" label="Policy Type" label-for="input-mdpolicytype">
                <b-form-select
                    id="input-mdpolicytype"
                    v-model="localForm.policy_type"
                    :options="policyTypeOptions"
                    required
                ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- If Annual state Max Duration per trip: (31 or more days) -->
                <b-form-group id="input-group-mdpolicyduration" label-for="input-mdpolicyduration">
                <template #label>
                    Trip Duration (Days)
                    <span v-if="calculatedDuration && calculatedDuration > 90" v-b-tooltip.hover.top="'Trips over 90 days are usually better suited for Annual policies'">
                        <i class="fa-solid fa-circle-info fa-lg cursor-pointer text-primary"></i>
                    </span>
                </template>
                <b-form-input
                    id="input-mdpolicyduration"
                    :value="calculatedDuration"
                    type="number"
                    readonly
                ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- Destination (Countries to be visited) -->
                <b-form-group id="input-group-mddestination" label="Destination (Countries to be visited)" label-for="input-mddestination">
                <b-form-input
                    id="input-mddestination"
                    v-model="localForm.destination"
                    type="text"
                    minlength="3"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- Basic, Extended, Luxury, Study or Travel Agent Leisure Cover -->
                <b-form-group id="input-group-mdpolicycover" label="Cover" label-for="input-mdpolicycover">
                <b-form-select
                    id="input-mdpolicycover"
                    v-model="localForm.policy_cover"
                    :options="policyCoverOptions"
                    required
                ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- Cost of Holiday/Trip per person -->
                <b-form-group id="input-group-mdcost" label="Cost of Holiday/Trip per person" label-for="input-mdcost">
                <b-form-input
                    id="input-mdcost"
                    v-model="localForm.cost"
                    type="number"
                    step="0.01"
                    required
                ></b-form-input>
                </b-form-group>
            </b-col>
            </b-row>
        
            <b-row class="mt-1">
            <b-col cols="12">
                <b-form-group id="input-group-mdconditions" label="(Potential) Pre-existing medical conditions of You and Co-travelers applying for insurance (Before filling this, please read below, pp. 3-6)" label-for="input-mdconditions">
                <b-form-textarea
                    id="input-mdconditions"
                    v-model="localForm.conditions"
                    placeholder="List any pre-existing medical conditions for you and co-travelers..."
                    rows="4"
                    minlength="3"
                    required
                />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- Hazardous Activities Required (I.e. Skiing, Scuba etc.) -->
                <b-form-group id="input-group-mdhazardous" label-for="input-mdhazardous">
                <template #label>
                    Hazardous Activities Required (I.e. Skiing, Scuba etc.)
                    <span class="text-muted">(Optional)</span>
                </template>
                <v-select 
                  ref="viaSelectAct"
                  multiple
                  input-id="input-mdhazardous"
                  v-model="localForm.hazardous_activities"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="hazardous_options"
                  :reduce="option => option.value"
                  :taggable="false"
                  @search:blur="onSearchActivities"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-- Other Special Requests (Specify) -->
                <b-form-group id="input-group-special-requests" label-for="input-mdspecialrequests">
                <template #label>
                    Other Special Requests (Specify)
                    <span class="text-muted">(Optional)</span>
                </template>
                <b-form-input
                    id="input-mdspecialrequests"
                    v-model="localForm.special_requests"
                    type="text"
                ></b-form-input>
                </b-form-group>
            </b-col>
            </b-row>

            <b-row class="mt-1">
            <b-col cols="12">
                <h6 class="font-weight-bolder">You must confirm that you have read and accepted the following to purchase this insurance by selecting “Yes”. If you are unable to agree with any of the following statements, then you are unable to continue with the purchase of this insurance. </h6>
            </b-col>
            </b-row>
            
            <b-row class="mt-1">
            <b-col cols="12">
                <div class="mb-half">
                    <b>Introduction:</b> This is a travel insurance Policy that, subject to the terms, conditions and exclusions contained in the Policy Wording, provides certain financial protection and medical assistance for your Trip(s). When buying this insurance, you will be supplied with four documents: <b>a) a Policy Wording</b> that details the terms and conditions and exclusions of coverage, <b>b) a Validation Certificate</b> that contains the basic provisions of your specified Policy, <b>c) a Schedule of Coverage</b> that states all benefits of the Policy type you purchased (in table form), followed by a notice of important information, and <b>d) an Insurance Product Information Document (IPID)</b> which provides a summary of the main cover and exclusions for a Regular Travel Insurance. We strongly recommend you review this information and raise any queries or concerns you may have before purchasing this insurance.
                </div>
                <b-form-group label-for="input-declaration-intro">
                    <b-form-radio-group
                        id="input-declaration-intro"
                        v-model="localForm.declarations.introduction"
                        :options="[
                        { text: 'Yes', value: true },
                        { text: 'No', value: false }
                        ]"
                        name="intro-radios"
                        inline
                        required
                    />
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <div class="mb-half">
                    This insurance is not personalised to your specific individual circumstances, unless otherwise agreed. Complete pre-contractual and contractual information about this product is provided in the <b>Validation Certificate, Schedule of Coverage and Policy Wording.</b> You have a right to cancel this insurance and receive a full refund up to 14 days from the date that you receive the Policy Documents at the start of insurance provided that no Insured Person has travelled, coverage has not already commenced and no claim under this Policy has been made or is intended to be made. The Policy terms, conditions and exclusions apply to all Insured Persons named on the <b>Validation Certificate</b> travelling with you and, if you are arranging this insurance on behalf of other people, it is your responsibility to ensure the coverage provided is suitable for the needs of all Insured Persons.
                </div>
                <b-form-group label-for="input-declaration-cover">
                    <b-form-radio-group
                        id="input-declaration-cover"
                        v-model="localForm.declarations.coverage"
                        :options="[
                        { text: 'Yes', value: true },
                        { text: 'No', value: false }
                        ]"
                        name="cover-radios"
                        inline
                        required
                    />
                </b-form-group>
            </b-col>
            </b-row>

            <b-row class="mt-1">
            <b-col cols="12">
                <h6 class="font-weight-bolder">Questions you must answer with a Yes or No:</h6>
            </b-col>
            </b-row>

            <b-row class="mt-1">
            <b-col cols="12">
                <div class="mb-half">
                    1. I have read and understood the introduction statement above and the coverage provided is suitable for the needs of all parties named on the <b>Validation Certificate</b>.
                </div>
                <b-form-group label-for="input-declaration-q1">
                    <b-form-radio-group
                        id="input-declaration-q1"
                        v-model="localForm.questions.q1"
                        :options="[
                        { text: 'Yes', value: true },
                        { text: 'No', value: false }
                        ]"
                        name="q1-radios"
                        inline
                        required
                    />
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <div class="mb-half">
                    2. I accept that coverage is limited and subject to conditions, exclusions and excesses and that this Insurance Policy contains conditions and exclusions in relation to geographical areas, sporting activities and the health condition of the Insured Persons and of others who might not be travelling with an Insured Person but whose wellbeing the Insured Person’s trip may depend upon. <b>Yes/No</b> (If No cannot proceed with purchase.)
                </div>
                <b-form-group label-for="input-declaration-q2">
                <b-form-radio-group
                    id="input-declaration-q2"
                    v-model="localForm.questions.q2"
                    :options="[
                    { text: 'Yes', value: true },
                    { text: 'No', value: false }
                    ]"
                    name="q2-radios"
                    inline
                    required
                />
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <div class="mb-half">
                    3. I accept that all Insured Persons must comply with the conditions relating to pre-existing medical conditions and health changes in order to have the full protection of this insurance and that if an Insured Person does not comply with these conditions the insurer may cancel the insurance or refuse to deal with an Insured Person’s claim or reduce the amount of any claim payment. <b>Yes/No</b> (If No cannot proceed with purchase.)
                </div>
                <b-form-group label-for="input-declaration-q3">
                    <b-form-radio-group
                        id="input-declaration-q3"
                        v-model="localForm.questions.q3"
                        :options="[
                        { text: 'Yes', value: true },
                        { text: 'No', value: false }
                        ]"
                        name="q3-radios"
                        inline
                        required
                    />
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <div class="mb-half">
                    4. I am aware that medical coverage for treatment costs is not included in my Home Area around my residence and limited solely to emergency treatment costs whilst I am travelling outside my home area (also applies for inland Trips under certain conditions; please see your <b>Policy Wording</b>) and that such treatment is limited to emergency necessary treatment that cannot be safely delayed until I am medically repatriated by the appointed 24-Hour Assistance Service detailed on my Policy. <b>Yes/No</b> (If No cannot proceed with purchase.)
                </div>
                <b-form-group label-for="input-declaration-q4">
                    <b-form-radio-group
                        id="input-declaration-q4"
                        v-model="localForm.questions.q4"
                        :options="[
                        { text: 'Yes', value: true },
                        { text: 'No', value: false }
                        ]"
                        name="q4-radios"
                        inline
                        required
                    />
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <div class="mb-half">
                    5. I agree that in the event I need medical treatment abroad I will arrange for the 24-Hour Assistance Service to be contacted as soon as possible and that they will be solely responsible for pre-authorising necessary medical treatment and expenses and/or arranging medical repatriation. <b>Yes/No</b> (If No cannot proceed with purchase.)
                </div>
                <b-form-group label-for="input-declaration-q5">
                <b-form-radio-group
                    id="input-declaration-q5"
                    v-model="localForm.questions.q5"
                    :options="[
                    { text: 'Yes', value: true },
                    { text: 'No', value: false }
                    ]"
                    name="q5-radios"
                    inline
                    required
                />
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <div class="mb-half">
                    6. I am aware that I have a choice of Single Trip and Annual Multi-Trip policy options with different Benefit Levels and I confirm that I am satisfied with the choice that I have made.
                </div>
                <b-form-group label-for="input-declaration-q6">
                <b-form-radio-group
                    id="input-declaration-q6"
                    v-model="localForm.questions.q6"
                    :options="[
                    { text: 'Yes', value: true },
                    { text: 'No', value: false }
                    ]"
                    name="q6-radios"
                    inline
                    required
                />
                </b-form-group>
            </b-col>
            </b-row>

            <b-row class="mt-1">
            <b-col cols="12">
                <h6 class="font-weight-bolder">IMPORTANT INFORMATION</h6>
                <div class="border">
                <p class="m-2"><b>This is not a private medical insurance.</b> If you need any emergency medical treatment or emergency travel assistance whilst abroad, please contact <b>HEALTHWATCH ASSISTANCE 24 Hour Emergency Helpline:</b></p>
                <ul>
                    <li>Telephone: +30 (0) 2313 084518</li>
                    <li>Telephone: +30 (0) 2311 801618</li>
                    <li>Email: assistance@healthwatch.gr</li>
                </ul>
                <p class="m-2"><b>Not contacting Healthwatch Assistance, or not following our instructions, could affect your claim. Full details are shown in the Policy Wording under “Part 3 –How to file a Claim & other important procedural details”.</b></p>
                </div>
                <div class="mt-2">
                <p>There are conditions which apply to the whole of this insurance Policy and full details of these can be found in the <b>Policy Wording</b> under <b>“Part 2 – General Conditions and Exclusions”.</b></p>
                <p>There are conditions which relate specifically to making a claim, and these can be found in <b>Policy Wording</b> under <b>“Part 3 – How to file a Claim & other important procedural details”.</b></p>
                <p>There are conditions that only apply to specific sections; these can be found under the <b>“Special conditions regarding the claim filing process”</b> heading in each (Sub-)Section.</p>
                <p>If <b>you</b> do not meet these conditions, <b>we</b> may need to reject a claim payment or a claim payment could be reduced. In some circumstances, the Policy may be cancelled.</p>
                </div>
            </b-col>
            </b-row>

            <b-row class="mt-1">
            <b-col cols="12">
                <h6 class="font-weight-bolder"><u>Declaration of Medical Conditions and Health Changes</u></h6>
                <div class="border">
                <p class="m-2">This document contains conditions and exclusions in relation to <b>your</b> health and of others who might not be travelling with <b>you</b> but whose well-being <b>your Trip</b> may depend upon.</p>
                <p class="m-2"><b>You</b> must comply with the following conditions relating to <b>Pre-existing medical conditions</b> and health changes in order to have the full protection of this insurance. If <b>you</b> do not comply with these conditions, <b>we</b> may cancel the insurance, or refuse to deal with <b>your</b> claim or reduce the amount of any claim payment.</p>
                </div>
                <div class="mt-2">
                <h6 class="font-weight-bolder">Pre-existing Medical Conditions</h6>
                <p>It is a necessary precondition for <b>Us</b>, in order to be held liable for any insurance compensation, that <b>You</b> disclose to <b>Us</b> any disabilities, conditions or illnesses for which <b>You</b> and/or another Insured Person herewith have received or required medical or psychiatric treatment or counselling services within a period of twelve (12) months prior to the commencement of the Period of Insurance or – if the insurance takes effect later – the effective date of the Insured Person’s inclusion to the policy. Failure to comply with the policy stipulations in this regard will result in a lapse of the Insured’s right to file a Claim or a reduction of the payable amount.</p>
                <p>In relation to this policy, as <b>pre-existing medical conditions</b> are considered (but not limited to):</p>
                <ol class="bold-letters" type="a">
                    <li>
                    any respiratory (relating to the lungs or to the breathing process) condition or heart condition, stroke, Crohn’s disease, epilepsy or cancer for which a prospective Insured Person has hitherto received treatment (including surgery, tests or examinations by a medical practitioner and prescribed drugs or medication);
                    </li>

                    <li>
                    any disease, illness or injury for which a prospect Insured Person has received surgery, inpatient treatment or examinations in a hospital or clinic within the last twelve (12) months prior to the commencement of the Period of Insurance or – if it occurs later – the effective date of the Insured Person’s inclusion to the policy;
                    </li>

                    <li>
                    any disease, illness or injury for which a prospect Insured Person is taking prescribed drugs or medication;
                    </li>

                    <li>
                    any medical condition for which a prospective Insured Person has received terminal prognosis;
                    </li>

                    <li>
                    any medical condition that a prospective Insured Person is aware of but of which it has had no medical diagnosis;
                    </li>

                    <li>
                    any medical condition for which a prospective Insured Person is on a waiting list or has been acknowledged in relation to the need for surgery, treatment or examination at a Medical Institution.
                    </li>
                </ol>
                </div>
            </b-col>
            </b-row>

            <b-row class="mt-1">
            <b-col cols="12">
                <h6 class="font-weight-bolder"><u>No Screen Conditions</u></h6>
                <p><b>Pre-existing medical conditions</b> included in the following list are not excluded from coverage. All words in brackets must apply to the <b>Insured Person.</b></p>
                <p>The condition must have been stable and well-controlled for the last 12 months.</p>
                <p>‘Stable and well-controlled’ means the condition has been controlled by medication administered <b>by a medical practitioner</b> <u>and</u> <b>you</b> have not required a hospital admission or referral to a specialist as a result of a worsening of <b>your</b> condition within the last 12 months.</p>
                <b-list-group class="mb-1">
                <b-list-group-item>• Acne</b-list-group-item>
                <b-list-group-item>• ADHD - Attention Deficit Hyperactivity Disorder</b-list-group-item>
                <b-list-group-item>• Any disabilities impairing mobility, vision or mental health (provided <b>you</b> are accompanied by an appropriate carer for when any assistance is required).</b-list-group-item>
                <b-list-group-item>• Arthritis - Juvenile, Osteoarthritis, Rheumatoid or Psoriatic Arthritis, Reiter’s Syndrome, Rheumatism. 
                    <span class="d-block">(-The arthritis must not affect the back more than any other area of the body; and</span>
                    <span class="d-block">-<b>You</b> must not be taking more than 2 medications; and</span>
                    <span class="d-block">-<b>You</b> must not require any mobility aids, other than a walking stick; and</span>
                    <span class="d-block">-There must have been no dislocations or any joint replacements; and</span>
                    <span class="d-block">-<b>You</b> must not be awaiting surgery; and</span>
                    <span class="d-block">-<b>You</b> must have no lung problems/respiratory disorders.)</span>
                </b-list-group-item>
                <b-list-group-item>• Allergies (limited to Rhinitis, Chronic Sinusitis, Eczema, Food Intolerance & Hay Fever)</b-list-group-item>
                <b-list-group-item>• Asthma (-providing it was diagnosed before age 50; and <b>you</b> are taking/using no more than 2 medications/inhalers)</b-list-group-item>
                <b-list-group-item>• Bell’s Palsy</b-list-group-item>
                <b-list-group-item>• Benign Positional Vertigo</b-list-group-item>
                <b-list-group-item>• Bladder Infection</b-list-group-item>
                <b-list-group-item>• Breast Cancer/Prostate Cancer (provided <b>you:</b>
                    <span class="d-block">- were diagnosed more than 12 months ago</span>
                    <span class="d-block">- reast or prostate at any time - in the case of cancer of the prostate <b>you</b> must have a prostate-specific antigen of 3.0 or less)</span>
                </b-list-group-item>
                <b-list-group-item>• Bunions</b-list-group-item>
                <b-list-group-item>• Carpal Tunnel Syndrome</b-list-group-item>
                <b-list-group-item>• Cataracts</b-list-group-item>
                <b-list-group-item>• Coeliac Disease</b-list-group-item>
                <b-list-group-item>• Congenital Blindness</b-list-group-item>
                <b-list-group-item>• Corneal Graft</b-list-group-item>
                <b-list-group-item>• Cystitis</b-list-group-item>
                <b-list-group-item>• Deafness</b-list-group-item>
                <b-list-group-item>• Diabetes (providing there have been no complications such as impaired kidney function, heart disease, peripheral vascular disease, leg or foot ulcers, retinal damage, nerve damage, leg or foot amputation, liver damage)</b-list-group-item>
                <b-list-group-item>• Dry Eye Syndrome</b-list-group-item>
                <b-list-group-item>• Deep Vein Thrombosis (DVT) – (provided <b>you</b> were diagnosed more than 12 months ago; and you are currently stable and well controlled on anti-coagulant (blood thinning) medication (such as Warfarin) taken purely as a DVT preventative and not related to any heart related condition). -If you are being treated as a result of a pulmonary embolism or have been prescribed anti-coagulants as a result of being at high risk of blood clots due to an abnormal heartbeat (atrial fibrillation) or because of a mechanical heart valve or similar cardiac device or having a blood clotting disorder (such as thrombophilia) or as a result of a recent operation then there is no cover under this policy.</b-list-group-item>
                <b-list-group-item>• Eczema</b-list-group-item>
                <b-list-group-item>• Enlarged Prostate (benign only)</b-list-group-item>
                <b-list-group-item>• Essential Tremor</b-list-group-item>
                <b-list-group-item>• Folate Deficiency</b-list-group-item>
                <b-list-group-item>• Fungal Nail Infection</b-list-group-item>
                <b-list-group-item>• Gallbladder Removal (provided there were no complications)</b-list-group-item>
                <b-list-group-item>• Gastric Reflux</b-list-group-item>
                <b-list-group-item>• Glaucoma</b-list-group-item>
                <b-list-group-item>• Goitre</b-list-group-item>
                <b-list-group-item>• Gout</b-list-group-item>
                <b-list-group-item>• Hiatus Hernia</b-list-group-item>
                <b-list-group-item>• High Cholesterol</b-list-group-item>
                <b-list-group-item>• Hormone Replacement Therapy – HRT</b-list-group-item>
                <b-list-group-item>• Hypertension - High Blood Pressure: (Providing you have not been diagnosed with any heart disease, heart attack, heart failure, peripheral artery/vascular disease, stroke or kidney disease)</b-list-group-item>
                <b-list-group-item>• Hypotension - Low Blood Pressure (provided it is not associated with any underlying condition)</b-list-group-item>
                <b-list-group-item>• Impetigo</b-list-group-item>
                <b-list-group-item>• Insulin Resistance</b-list-group-item>
                <b-list-group-item>• Macular Degeneration</b-list-group-item>
                <b-list-group-item>• Meniere’s Disease</b-list-group-item>
                <b-list-group-item>• Migraine</b-list-group-item>
                <b-list-group-item>• Osteoporosis - Osteopenia, Fragile Bones (provided there have been no broken bones within the last 5 years)</b-list-group-item>
                <b-list-group-item>• Pernicious Anaemia</b-list-group-item>
                <b-list-group-item>• Raynaud’s Disease</b-list-group-item>
                <b-list-group-item>• RSI (Repetitive Strain Injury/Tendinitis)</b-list-group-item>
                <b-list-group-item>• Sinusitis</b-list-group-item>
                <b-list-group-item>• Tendonitis</b-list-group-item>
                <b-list-group-item>• Tinnitus</b-list-group-item>
                <b-list-group-item>• Tonsillitis</b-list-group-item>
                <b-list-group-item>• Underactive or Overactive Thyroid</b-list-group-item>
                </b-list-group>
            </b-col>
            </b-row>

            <b-row class="mt-1">
            <b-col cols="12">
                <h6 class="font-weight-bolder"><u>Health Changes</u></h6>
                <p>If <b>Your</b> health conditions change, whether they deteriorate or improve, after the commencement of the <b>Period of Insurance</b> as well as after the date <b>Your</b> tickets or confirmation of booking were issued, <b>You</b> must contact <b>Us</b> (see hereunder) so that <b>We</b> ensure no coverage is hence affected.
                <span class="d-block"><b>Your</b> health conditions are considered altered, when:</span>
                </p>
                <ul>
                <li><b>You</b> have been diagnosed with hitherto faultlessly unknown (to <b>You</b>) details of pre-existing medical conditions or new medical conditions; or</li>
                <li>changes in <b>Your</b> treatment method or received medication occur.</li>
                </ul>
                <div class="border text-center py-1 mb-1">
                <span class="d-block font-weight-bold"><b>Contact details – Safetravel.today</b></span>
                <span class="d-block font-weight-bold">Email: customer-support@safetravel.today / sales@safetravel.today</span>
                <span class="d-block font-weight-bold">Telephone number: <b>+30 210 7007135</b></span>
                <span class="d-block font-weight-bold">Office hours: 9 a.m. – 5 p.m. / Monday to Friday (excl. [greek] public holidays)</span>
                </div>
            </b-col>
            </b-row>

            <b-row class="mt-1">
            <b-col cols="12">
                <h6 class="font-weight-bolder"><u>Exclusions Relating to Health and Medical Conditions</u></h6>
                <p><b>1. Exclusions relating to health and medical conditions:</b> Any coverage under Section A (“Cancellation, Curtailment and Rearrangement Charges”), Section B (“Medical, Repatriation and other Expenses”) and Section C (“Personal Accident”) of this policy is excluded and upon that any claims deriving directly or indirectly from:</p>
                <ol type="a">
                <li>a medical condition You have under which a medical practitioner has advised <b>You</b> not to travel (or would have advised <b>You</b> so, had <b>You</b> sought their advice), but despite this you set out to travel;</li>
                <li>any surgery, treatment or examination for the receival of which <b>You</b> intend to travel outside of <b>Your Home area</b> (including any expenses incurred due to the discovery of other medical conditions during and/or complications arising from these procedures);</li>
                <li>any medical condition for which <b>You</b> are not taking the recommended treatment or prescribed medication as directed by a medical practitioner;</li>
                <li>Your travelling conduct being contrary to health guidelines and regulations adopted by:
                    <span class="d-block">– the airline (or booking) company to which the flight was booked, or by any other legal person that provides services at the airport on behalf of the airline company, or</span>
                    <span class="d-block">– any other provider of public transport services.</span>
                </li>
                </ol>
                <p>2. Pregnancy: The submission of a claim owing to cancellation due to pregnancy should be based on a written confirmation issued by a medical practitioner. by a medical practitioner. The travel dates must also fall within the beginning of the first day of the 21st week and the end of the last day of the 25th week of pregnancy. In case the purchase of the policy precedes the confirmation of pregnancy, coverage under Section A (“Cancellation, Curtailment and Rearrangement Charges”) is provided when <b>We</b> are contacted within fourteen (14) days after the confirmation of the pregnancy. When confirmed pregnancy precedes the purchase of a policy, it is required that <b>You</b> disclose to <b>Us</b> the ongoing pregnancy (based on a written confirmation written by a medical practitioner) immediately or at maximum within fourteen (14) days after the day the policy was purchased. Given that a filed claim was paid for this reason, <b>Your</b> policy shall be considered terminated and thus no further coverage will be provided through it.</p>
                <p>If <b>You</b> decide not to cancel <b>Your Trip</b>, coverage under all sections of this policy will be provided according to the standard terms and conditions as laid down in this document. Therefore, no coverage shall be deemed available under this policy in relation to pregnancy and/or childbirth, unless during the respective <b>Trip</b>:</p>
                <ol type="a">
                <li><b>You</b> suffer a heavy <b>Bodily Injury;</b> or</li>
                <li><b>You</b> contract a serious <b>Illness or disease;</b> or</li>
                <li>any <b>Complication collateral to pregnancy</b> occurs</li>
                </ol>
                <p>Coverage for the abovementioned events shall be provided by and large until the end of the 25th week of pregnancy. As an exception to this, if the pregnancy results from a course of in vitro fertilisation (IVF) or if twins or multiple infants are carried, coverage of the referred events shall be provided <b>until the end of the 23rd week of pregnancy.</b> Regardless of any approval to travel granted by a medical practitioner, an excess of the 25th (or exceptionally the 23rd) week of pregnancy shall lead to a withdrawal of coverage.</p>
                <div class="border text-center mb-1 rounded bg-warning-rgba font-weight-bold">
                    <p class="m-2">I/we declare that to the best of my/our knowledge and belief no information that may influence underwriters in their acceptance of this insurance has been withheld. I/we undertake to declare any changes in the physical or mental health of persons insured which may affect the cover provided. I/we declare that I/we have read the key facts document accompanying this application and will be bound by policy terms and conditions.</p>
                    <b-row class="px-2">
                    <b-col cols="12" md="6">
                        <!-- signature -->
                        <b-form-group id="input-group-signature" label="Full Name (as Signature)" label-for="input-signature">
                        <b-form-input
                            id="input-signature"
                            v-model="localForm.signature"
                            minlength="6"
                            required
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <!-- signature date -->
                        <b-form-group id="input-group-signature_date" label="Date" label-for="input-signature_date">
                        <b-form-input
                            id="input-signature_date"
                            v-model="localForm.signature_date"
                            type="date"
                            readonly
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                    </b-row>
                </div>
                <p class="font-weight-bolder">After this completed Application Form is submitted to Us (either directly or indirectly through an Intermediary), we shall respond to the sender within forty-eight (48) hours regarding the undertaking of insurance (or not) in accordance with the details provided in this localForm. 
                <span class="d-block">If we do undertake the insurance, we shall propose a certain standard premium for the applicant’s case and ask for a full payment of such premium (through bank transfer in the bank account details provided in the responding e-mail).</span>
                <span class="d-block">Only after the payment has been made, we shall proceed with sending the proper documentation to the applicant, who shall be then considered as an Insured Person retrospectively, from the date they applied for the insurance or the date otherwise stated by Us.</span></p>
                <div class="border text-center py-1 mb-1">
                <span class="d-block font-weight-bold"><b>Safetravel.today Insurance Brokers, Private Limited Company (“Safetravel.today”)</b>,</span>
                <span class="d-block font-weight-bold">incorporated and established in Athens, Greece; Registered Number: 151591603000; Registered Address: Xenofontos 85–87, Kallithea, Athens, Greece; P.C. 17673.</span>
                <span class="d-block font-weight-bold">Email: customer-support@safetravel.today / sales@safetravel.today</span>
                <span class="d-block font-weight-bold">Telephone number: <b>+30 210 7007135</b></span>
                <span class="d-block font-weight-bold">Office hours: 9 a.m. – 5 p.m. / Monday to Friday (excl. [greek] public holidays)</span>
                </div>
                <p>The information that you supply on this form will only be used by us to assess whether we will provide coverage for the disclosed medical conditions. This information will not be passed to any third party.</p>
                <p>For full details of what data we collect about you, how we use it, who we share it with, how long we keep it and your rights relating to your personal data, please refer to our <b>Data Protection Notice</b> in the Policy Wording (under <b>Part 8 – “Compliance, Regulatory and other Information”</b>) and our <b>Personal Data Privacy Policy</b> or please ask a member of staff for details.</p>
            </b-col>
            </b-row>

            <b-button size="md" type="submit" variant="outline-primary">Submit</b-button>
        </b-form>

        <template #modal-footer>
            <b-button variant="secondary" @click="closeModal">
            Cancel
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import vSelect from 'vue-select'
import {
  BRow,
  BCol,
  BFormTags,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BFormRadio,
  BFormInvalidFeedback,
  VBTooltip,
  BAlert,
  BCollapse,
  BButton,
  BButtonGroup,
  VBToggle,
  BCard,
  BSidebar,
  BJumbotron,
  BFormRadioGroup,
  BFormCheckbox,
  BLink,
  BPopover,
  VBModal,
  BDropdown,
  BDropdownItem, 
  BDropdownDivider,
  BForm,
  BTable,
  BListGroup,
  BListGroupItem,
  BInputGroup,
  BInputGroupAppend
} from 'bootstrap-vue';
export default {
  name: "MedicalModal",
  components: {
    vSelect,
    BRow,
    BCol,
    BFormTags,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormRadio,
    BFormInvalidFeedback,
    VBTooltip,
    BAlert,
    BCollapse,
    BButton,
    BButtonGroup,
    VBToggle,
    BCard,
    BSidebar,
    BJumbotron,
    BFormRadioGroup,
    BFormCheckbox,
    BLink,
    BPopover,
    VBModal,
    BDropdown,
    BDropdownItem, 
    BDropdownDivider,
    BForm,
    BTable,
    BListGroup,
    BListGroupItem,
    BInputGroup,
    BInputGroupAppend
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    value: { type: Boolean, required: true },      
    medicalForm: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },    
    pdfLink: String,
    travellerSelect: Array,
    policyTypeOptions: Array,
    policyCoverOptions: Array,
    dateToday: String,
  },
  data() {
    return {
      hazardous_options: [],
      localForm: JSON.parse(JSON.stringify(this.medicalForm))
    };
  },
  computed: {
    token_id() {
      return this.$store.state.app?.userData?.id ?? null
    },
    showModal: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    },
    calculatedDuration() {
        if (!this.localForm.start_date || !this.localForm.end_date) return null;
        // Return 365 days for annual policies
        if (this.localForm.policy_type === 'annual' || this.localForm.policy_type === 'Annual') {
            return 365;
        }
        const startDate = new Date(this.localForm.start_date);
        const endDate = new Date(this.localForm.end_date);
        if (endDate < startDate) return null;
        const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    }
  },
  watch: {
    // Fetch when modal opens
    showModal: {
      async handler(isOpen) {
        if (isOpen && this.hazardous_options.length === 0) {
          try {
            await this.fetchOptions();
          } catch (err) {
            console.error('Failed to load activities:', err);
          }
        }
      }
    },
    medicalForm: {
      handler(newVal) {
        this.localForm = JSON.parse(JSON.stringify(newVal));
      },
      deep: true
    },
    errors: {
        handler(newErrors) {
            if (Object.keys(newErrors).length > 0) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        if (this.$refs.mederrorAlert) {
                            const alertElement = this.$refs.mederrorAlert.$el;
                            const modalBody = alertElement.closest('.modal-body');
                            if (modalBody) {
                            modalBody.scrollTop = alertElement.offsetTop - 20;
                            }
                        }
                    }, 250);
                })
            }
        },
        deep: true
    },
  },
  methods: {
    onSearchActivities() {
      this.$refs.viaSelectAct.search = ''
    },
    handleSubmit() {
      this.$emit('medical-submit', JSON.parse(JSON.stringify(this.localForm)));
    },
    closeModal() {
      this.$emit('input', false);
    },
    addTraveller() {
        if (!this.localForm.travellers) {
            this.localForm.travellers = [];
        }
        // Limit to 10 travellers maximum
        if (this.localForm.travellers.length < 10) {
            this.localForm.travellers.push(this.createEmptyTraveller());
        } else {
            alert('Maximum 10 travellers allowed');
        }
    },
    removeTraveller(index) {
        // Ensure we always have at least one traveller (primary applicant)
        if (this.localForm.travellers.length > 1) {
            this.localForm.travellers.splice(index, 1);
        } else {
            alert('At least one traveller (Primary Applicant) is required');
        }
    },
    createEmptyTraveller() {
        return {
            title: null,
            firstname: '',
            lastname: '',
            dob: null,
            age: null,
        };
    },
    async fetchOptions() {
        const data_s = {
            token: this.token_id,
            jwt: window.$cookies.get("jwt") ?? null,
            product: 'product-single-300'
        }
        const response = await fetch('https://api-quote.safetravel.today/v2/app/get_product_addons', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data_s)
        })
        if (!response.ok) throw new Error(`Failed to fetch add-ons: HTTP ${response.status}`);
        const data = await response.json();
        if (data.error) {
            console.error('Error fetching medical add-ons:', data.error);
            return;
        }
        if (!Array.isArray(data)) {
            this.hazardous_options = [];
            return;
        }
        if (data.length === 0) {
            this.hazardous_options = [];
            return;
        }
        this.hazardous_options = data
        .filter(item => item && item.name)
        .map(item => ({
            label: item.name,
            value: item.name
        }));
    }
  }
};
</script>
<style scoped> 
  ::v-deep .vs__dropdown-option,
  ::v-deep .vs__selected {
    white-space: normal;
    word-break: break-word;
  }
  .msl_custom {
    margin-left:5px;
  }
  .mb-half {
    margin-bottom: 3px;
  }
  .bold-letters li::marker {
    font-weight: bold;
  }
  .bg-warning-rgba {
    background-color: rgba(255, 193, 7, 0.3);
    }
    .traveller-section {
    border: 1px solid #e3e6f0;
    border-radius: 6px;
    padding: 20px;
    background-color: #f8f9fa;
    margin-bottom: 10px;
  }
  .traveller-section:first-of-type {
    border-color: #007bff;
    background-color: #f0f7ff;
  }
</style>